// react and redux
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getDashboardTableFilings } from '../../../features/state/StateFiling-slice';
// UI imports
import PrivatePageLayout from '../../../layout/privatePageLayout/PrivatePageLayout';
import Table from '../../../components/stateful/table/Table';
import { GenerateColumnDefinition } from '../../../components/stateful/table/TableHelper';
import { ConstructEmptyDashboardColumnTemplate, DashboardColumnTemplate } from './templates/DashboardColumnTemplate';

function Dashboard(props: any) {
  const [columnData, setColumnData] = useState<any>(null);
  const values = useAppSelector((state) => state.filings.dashboardFilings);
  const fetchingValues = useAppSelector((state) => state.filings.fetchingDashboardFilings);
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<DashboardColumnTemplate[]>([]);

  useEffect(() => {
    if (values.length < 1) {
      dispatch(getDashboardTableFilings());
    }
    if (columnData === null) {
      generateColumnData();
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (rows.length < 1) {
      let newRows : DashboardColumnTemplate[] = values.map(
        (x: 
          { 
            docketNumberDto: { docketNumber: any; }; 
            filedOn: any; 
            filingFormName: any;
            agencyName: any; 
            titleNumber: any; 
            chapterNumber: any; 
            effectiveOn: any; 
          }
        ) => ({
        docketNumber: x.docketNumberDto.docketNumber,
        dateReceived: x.filedOn,
        typeOfFiling: x.filingFormName.match(/[A-Z][a-z]+|[0-9]+/g)!.join(' '),
        agencyName: x.agencyName,
        titleNumber: x.titleNumber,
        chapterNumber: x.chapterNumber,
        dateAccepted: x.effectiveOn,  
      }));
      setRows(newRows);  
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  const generateColumnData = async () => {
    let columns = await GenerateColumnDefinition(ConstructEmptyDashboardColumnTemplate());
    setColumnData(columns);
  }

  const renderDashboard = () => {
    return (
      <div>
        {columnData ? (
          <Table values={rows} columns={columnData} tableName="Dashboard" height="90vh" isLoading={fetchingValues} />
        ) : null}
      </div>
    );
  }

  return (
    <PrivatePageLayout>
      {renderDashboard()}
    </PrivatePageLayout>
  )
}

export default Dashboard